import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRatingScale = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 6,
			y: 7,
			width: 4,
			height: 10,
			rx: 2,
			stroke: "#999999",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 13,
			y: 1,
			width: 4,
			height: 16,
			rx: 2,
			stroke: "#999999",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2,
			cy: 16,
			r: 2,
			fill: "#999999"
		})
	]
});
export default SvgRatingScale;
